/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPlaceholderResponse,
  ListRequest,
  ListResponseOfEquipmentSuggestion,
  ListResponseOfFacilitySubTypeSuggestion,
  ListResponseOfPlaceholderListItem,
  PlaceholderWriteRequest
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const getProductsEquipmentSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfEquipmentSuggestion>(
      {url: `/api/products/equipment/suggestions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetProductsEquipmentSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsEquipmentSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getProductsEquipmentSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getProductsEquipmentSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getProductsEquipmentSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getProductsEquipmentSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetProductsEquipmentSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getProductsEquipmentSuggestions>>>
    export type GetProductsEquipmentSuggestionsMutationBody = ListRequest
    export type GetProductsEquipmentSuggestionsMutationError = ErrorType<unknown>

    export const useGetProductsEquipmentSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsEquipmentSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getProductsEquipmentSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetProductsEquipmentSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getProductsFacilitySubTypeSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfFacilitySubTypeSuggestion>(
      {url: `/api/products/facility-subtypes/suggestions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetProductsFacilitySubTypeSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsFacilitySubTypeSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getProductsFacilitySubTypeSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getProductsFacilitySubTypeSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getProductsFacilitySubTypeSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getProductsFacilitySubTypeSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetProductsFacilitySubTypeSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getProductsFacilitySubTypeSuggestions>>>
    export type GetProductsFacilitySubTypeSuggestionsMutationBody = ListRequest
    export type GetProductsFacilitySubTypeSuggestionsMutationError = ErrorType<unknown>

    export const useGetProductsFacilitySubTypeSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsFacilitySubTypeSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getProductsFacilitySubTypeSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetProductsFacilitySubTypeSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const createProductsPlaceholder = (
    placeholderWriteRequest: PlaceholderWriteRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/products/placeholders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: placeholderWriteRequest, signal
    },
      );
    }
  


export const getCreateProductsPlaceholderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductsPlaceholder>>, TError,{data: PlaceholderWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProductsPlaceholder>>, TError,{data: PlaceholderWriteRequest}, TContext> => {

const mutationKey = ['createProductsPlaceholder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductsPlaceholder>>, {data: PlaceholderWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  createProductsPlaceholder(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProductsPlaceholderMutationResult = NonNullable<Awaited<ReturnType<typeof createProductsPlaceholder>>>
    export type CreateProductsPlaceholderMutationBody = PlaceholderWriteRequest
    export type CreateProductsPlaceholderMutationError = ErrorType<unknown>

    export const useCreateProductsPlaceholder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductsPlaceholder>>, TError,{data: PlaceholderWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProductsPlaceholder>>,
        TError,
        {data: PlaceholderWriteRequest},
        TContext
      > => {

      const mutationOptions = getCreateProductsPlaceholderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const productsPlaceholderList = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfPlaceholderListItem>(
      {url: `/api/products/placeholders/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getProductsPlaceholderListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsPlaceholderList>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof productsPlaceholderList>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['productsPlaceholderList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsPlaceholderList>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  productsPlaceholderList(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsPlaceholderListMutationResult = NonNullable<Awaited<ReturnType<typeof productsPlaceholderList>>>
    export type ProductsPlaceholderListMutationBody = ListRequest
    export type ProductsPlaceholderListMutationError = ErrorType<unknown>

    export const useProductsPlaceholderList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsPlaceholderList>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productsPlaceholderList>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getProductsPlaceholderListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateProductsPlaceholder = (
    id: string,
    placeholderWriteRequest: PlaceholderWriteRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/products/placeholders/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: placeholderWriteRequest
    },
      );
    }
  


export const getUpdateProductsPlaceholderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductsPlaceholder>>, TError,{id: string;data: PlaceholderWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProductsPlaceholder>>, TError,{id: string;data: PlaceholderWriteRequest}, TContext> => {

const mutationKey = ['updateProductsPlaceholder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductsPlaceholder>>, {id: string;data: PlaceholderWriteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProductsPlaceholder(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductsPlaceholderMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductsPlaceholder>>>
    export type UpdateProductsPlaceholderMutationBody = PlaceholderWriteRequest
    export type UpdateProductsPlaceholderMutationError = ErrorType<unknown>

    export const useUpdateProductsPlaceholder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductsPlaceholder>>, TError,{id: string;data: PlaceholderWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProductsPlaceholder>>,
        TError,
        {id: string;data: PlaceholderWriteRequest},
        TContext
      > => {

      const mutationOptions = getUpdateProductsPlaceholderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getProductsPlaceholder = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetPlaceholderResponse>(
      {url: `/api/products/placeholders/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetProductsPlaceholderQueryKey = (id?: string,) => {
    return [
    `/api/products/placeholders/${id}`
    ] as const;
    }

    
export const getGetProductsPlaceholderQueryOptions = <TData = Awaited<ReturnType<typeof getProductsPlaceholder>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholder>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsPlaceholderQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsPlaceholder>>> = ({ signal }) => getProductsPlaceholder(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsPlaceholderQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsPlaceholder>>>
export type GetProductsPlaceholderQueryError = ErrorType<void>


export function useGetProductsPlaceholder<TData = Awaited<ReturnType<typeof getProductsPlaceholder>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsPlaceholder>>,
          TError,
          Awaited<ReturnType<typeof getProductsPlaceholder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsPlaceholder<TData = Awaited<ReturnType<typeof getProductsPlaceholder>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsPlaceholder>>,
          TError,
          Awaited<ReturnType<typeof getProductsPlaceholder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsPlaceholder<TData = Awaited<ReturnType<typeof getProductsPlaceholder>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholder>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductsPlaceholder<TData = Awaited<ReturnType<typeof getProductsPlaceholder>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholder>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductsPlaceholderQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteProductsPlaceholder = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/products/placeholders/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductsPlaceholderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductsPlaceholder>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductsPlaceholder>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteProductsPlaceholder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductsPlaceholder>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductsPlaceholder(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductsPlaceholderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductsPlaceholder>>>
    
    export type DeleteProductsPlaceholderMutationError = ErrorType<unknown>

    export const useDeleteProductsPlaceholder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductsPlaceholder>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductsPlaceholder>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductsPlaceholderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    